import { Icon } from '@mui/material';
import { UserContext } from 'App';
import MDBox from 'components/MDBox';
import { useContext, useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import Swal from 'sweetalert2';
import AppointmentsApi from '../../../../Classes/API/Appointments/AppointmentsApi';
import SearchStringOrIntReq from '../../../../Classes/Models/Requests/SearchStringOrIntReq';
import AccSessionDiv from './AccSessionDiv';
const AppHourCell2 = ({ AppHour, setSelectedAppHour, LoadReminders, AppDay,
    EnableFacilityModal, EnableAppointmentModal, setMovingSession, 
    PasteSession, setIsLoaded, Reminders }) => {
    const navigate = useNavigate();
    const [ReminderColor, setReminderColor] = useState("");
    const [ShowReminders, setShowReminders] = useState(false);

    let User = useContext(UserContext);

    useEffect(() => {
        GetReminderSettings();
    }, [AppHour, Reminders]);


    const GetReminderSettings = () => {
        let reminders = Reminders.filter(x => x.appointmentHourId == AppHour.id);
        if (reminders.length == 0) {
            return;
        }
        let reminderColor = "";
        let reminderText = "";
        for(let i = 0; i < reminders.length; i++){
            let reminder = reminders[i];
            let patient = reminder.patient;
            if(patient.countSinceLastEval >= patient.lastEvalReminder){
                reminderColor = "red";
                reminderText += `\n${patient.Id} - ${patient.countSinceLastEval}`;
                break;
            }
        }
        setReminderColor(reminderColor);
    }


    const GoToAccSessionDetails = (AccSession) => {
        navigate(
            '/AccountingSessions/Details',
            {
                state: {
                    SearchSession: AccSession,
                }
            }
        )
    }
    const DeleteAppointment = async (_accSess) => {
        console.log(User.userType);
        if(User.userType != "Admin" && User.userType != "SubAdmin"){
            Swal.fire({
                title: 'Invalid Permission',
                text: 'You are not allowed to delete this appointment',
                icon: 'error',
                confirmButtonText: 'Ok'
            })
            return;
        }
        let DeleteAppointmentReq = new SearchStringOrIntReq();
        DeleteAppointmentReq.SearchInt = _accSess.id;
        let confirmation = await Swal.fire({
            title: 'Are you sure?',
            text: "You won't be able to revert this!",
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Yes, delete it!'
        });
        if (!confirmation.value) {
            return;
        }
        Swal.fire({
            title: 'Deleting...',
            text: 'Please wait...',
            allowOutsideClick: false,
            allowEscapeKey: false,
            allowEnterKey: false,
            didOpen: () => {
                Swal.showLoading();
            }
        });
        let result = await AppointmentsApi.ClearAccountingSessionAppointmentHour(DeleteAppointmentReq);
        if (result.status == "Success") {
            Swal.fire(
                'Deleted!',
                'Your file has been deleted.',
                'success'
            ).then(() => {
                setIsLoaded(false);
            });
        }
        else {
            Swal.fire({
                title: 'Error',
                text: result.message,
                icon: 'error',
                confirmButtonText: 'Ok'
            })
        }
    }
     
    const GetSessions = (AppHour) => {
        let Buttons = []
        if (AppHour.getListedAccountingSessions.length > 0) {
            AppHour.getListedAccountingSessions.forEach(AccSession => {
                Buttons.push(
                    <AccSessionDiv AccSession={AccSession} GoToAccSessionDetails={GoToAccSessionDetails} 
                    DeleteAppointment={DeleteAppointment} 
                    EnableFacilityModal={EnableFacilityModal}
                    setMovingSession ={setMovingSession}
                    setIsLoaded = {setIsLoaded}
                    />
                )
            });
        }
        return Buttons
    }

    const GetReminders = () => {
        let reminders = Reminders.filter(x => x.appointmentHourId == AppHour.id);
        if (reminders.length == 0) {
            return [];
        }

        let Divs = [];
        for(let i = 0; i < reminders.length; i++){
            let reminder = reminders[i];
            let patient = reminder.patient;
            if(patient.countSinceLastEval < patient.lastEvalReminder){
                continue;
            }
            Divs.push(
                <div className="d-flex justify-content-between" style={{marginBottom: '5px', fontSize:"0.9em"}}>
                    <span className='badge badge-danger'
                    >{patient.getUser.name} has had {patient.countSinceLastEval} sessions with no ReEval</span>
                    <button className="btn btn-primary ml-3" onClick={(e) => {
                        e.target.disabled = true;
                        ResetCountSinceLastEval(patient);
                    }}>
                        <Icon>undo</Icon>
                    </button>
                </div>
            )
        }
        return Divs;
    }

    const ResetCountSinceLastEval = async (patient) => {
        let req = new SearchStringOrIntReq();
        req.SearchInt = patient.id;
        let result = await AppointmentsApi.ResetCountSinceLastEval(req);
        if(result.status == "Success"){
            Swal.fire({
                title: 'Success',
                text: "Count Since Last Eval has been reset",
                icon: 'success',
                confirmButtonText: 'Ok'
            }).then(() => {
                // setIsLoaded(false);
                LoadReminders();
            });
        }
        else{
            Swal.fire({
                title: 'Error',
                text: result.message,
                icon: 'error',
                confirmButtonText: 'Ok'
            })
        }
    }

            
    return (
        <MDBox className={`AppHourCell`}  sx={{
            border: `3px solid ${ReminderColor}`,
            borderRadius: '5px',
            padding: '5px',
            margin: '5px',
            
            '&:hover': {
                border: `5px solid ${ReminderColor}`,
            },
        }}>
            <div>

                {GetSessions(AppHour).map((session, index) => {
                    return (
                        <>
                            {session}
                        </>
                    )
                })}
            </div>
            <div className="d-flex justify-content-between">
                {
                    ((User.userType === "SubAdmin" || User.userType === "Admin") || 
                        (new Date(AppDay.dateDay).toLocaleDateString('en-GB') === new Date().toLocaleDateString('en-GB'))) 
                     && setSelectedAppHour &&
                    <button className="btn btn-sm btn-primary" onClick={() => {
                        // setSelectedAppHour(AppHour)
                        EnableAppointmentModal(true, AppHour)
                    }}>
                        <Icon>add</Icon>
                    </button>
                } 
                <span className="badge-sm">Id: {AppHour.id}</span>

                <button className="btn btn-sm btn-dark" onClick={() => {
                    setShowReminders(!ShowReminders)
                }}>
                    <Icon>?</Icon>
                </button>
                  
                <button className="btn btn-sm btn-primary" onClick={() => {
                    PasteSession(AppHour)
                }}>
                    <Icon>paste</Icon>
                </button>
          
            </div>{
                ShowReminders &&
                <div style={{marginTop: '1em',
                display: 'flex',
                flexDirection: 'column',
                justifyContent: 'center',
                alignItems: 'center',

                }}>
                    {GetReminders().map((reminder, index) => {
                        return (
                            <>
                                {reminder}
                            </>
                        )
                    })}

                </div>
            }
        </MDBox>
    );
}

export default AppHourCell2